import { interpolate, spring, useCurrentFrame, useVideoConfig } from "remotion";
import { COLORS, FONTS, SPRING } from "./theme";
import type { AccentName } from "./theme";

/**
 * Oversized metric that springs up and counts to `value`. For payoff beats.
 * `from`/`value` are numbers; `format` maps the eased number to its display string.
 */
export const MetricCounter: React.FC<{
  value: number;
  from?: number;
  startFrame?: number;
  durationFrames?: number;
  accent?: AccentName;
  prefix?: string;
  suffix?: string;
  decimals?: number;
  fontSize?: number;
  format?: (n: number) => string;
}> = ({
  value,
  from = 0,
  startFrame = 0,
  durationFrames = 30,
  accent = "green",
  prefix = "",
  suffix = "",
  decimals = 0,
  fontSize = 140,
  format,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const s = spring({
    frame: frame - startFrame,
    fps,
    config: SPRING.snappy,
    durationInFrames: durationFrames,
  });
  const n = interpolate(s, [0, 1], [from, value]);
  const text = format ? format(n) : `${prefix}${n.toFixed(decimals)}${suffix}`;
  return (
    <div
      style={{
        fontFamily: FONTS.display,
        fontWeight: 700,
        fontSize,
        lineHeight: 1,
        letterSpacing: "-0.03em",
        color: COLORS[accent],
        textShadow: `0 0 40px ${COLORS[accent]}55`,
      }}
    >
      {text}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
